import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {APIError} from 'data/errors/api-error';
import {
	GetHealthSpecialtyDescription,
	GetHealthSpecialtyDescriptionModel,
	GetHealthSpecialtyDescriptionParams,
} from 'domain/usecases/private/booking-flow/health/get-health-specialty-description';

export class RemoteGetHealthSpecialtyDescription implements GetHealthSpecialtyDescription {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetHealthSpecialtyDescriptionModel>,
	) {}

	async get({
		signal,
		...params
	}: GetHealthSpecialtyDescriptionParams): Promise<GetHealthSpecialtyDescriptionModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
